import { type FC } from "react";

import { css } from "@emotion/css";
import { Dropdown, Menu, MenuItem } from "@snapchat/snap-design-system";

import { useTopLensesStats } from "../../../hooks";
import { TopLensesOptions } from "../../../models";
import { DropdownItem } from "../../shared";

export const SelectTopLensesOption: FC = () => {
    const { selectedTopLensesLabel, selectedTopLenses, setSelectedTopLenses } = useTopLensesStats();

    return (
        <Dropdown
            overlay={
                <Menu
                    className={css`
                        width: 220px;
                    `}
                >
                    {TopLensesOptions.map(({ value, label }) => (
                        <MenuItem
                            key={value}
                            onClick={() => {
                                setSelectedTopLenses(value);
                            }}
                        >
                            <DropdownItem label={label} isSelected={value === selectedTopLenses} />
                        </MenuItem>
                    ))}
                </Menu>
            }
            buttonProps={{ label: selectedTopLensesLabel, type: "default", size: "regular" }}
        />
    );
};
